import { Store, Actions } from '@ngxs/store';
import { CameraService } from '../engine/camera.service';
import { EngineService } from '../engine/engine.service';
import { PaintService } from '../engine/paint.service';
import { defineProcedure } from './define-procedure';
import { getCameraProcedures, getCameraEvents } from './procedures/camera';
import { getSceneProcedures, getSceneEvents } from './procedures/scene';
import { defineEvent } from './define-event';
import { getHumanEvents, getHumanProcedures } from './procedures/human';
import { getTimelineEvents, getTimelineProcedures } from './procedures/timeline';
import { AnimationService } from '../engine/animation.service';
import { getInputEvents, getInputProcedures } from './procedures/input';
import { getUIEvents, getUIProcedures } from './procedures/ui';
import { ImageService } from '../shared/image.service';
import { getLabelsEvents, getLabelsProcedures } from './procedures/labels';
import { LabelsService } from '../story/labels.service';
import { BdGraphService } from 'src/lib/graph/graph.service';
import { HistoryService } from '../history/history.service';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
import * as i2 from "../engine/camera.service";
import * as i3 from "../engine/engine.service";
import * as i4 from "../engine/animation.service";
import * as i5 from "../shared/image.service";
import * as i6 from "../engine/paint.service";
import * as i7 from "../story/labels.service";
import * as i8 from "../../lib/graph/graph.service";
import * as i9 from "../history/history.service";
export class WidgetAPIHandler {
    constructor(store, actions, cameraService, engineService, animationService, imageService, paintService, labelsService, graphService, historyService) {
        this.store = store;
        this.actions = actions;
        this.cameraService = cameraService;
        this.engineService = engineService;
        this.animationService = animationService;
        this.imageService = imageService;
        this.paintService = paintService;
        this.labelsService = labelsService;
        this.graphService = graphService;
        this.historyService = historyService;
        this.webGLInfo = SceneJS.WEBGL_INFO;
    }
    listen() {
        this.initProcedures();
        this.initEvents();
    }
    initEvents() {
        getHumanEvents().forEach(event => {
            defineEvent(event.eventName, event.aliasEvents, event.mapFn);
        });
        getSceneEvents().forEach(event => {
            defineEvent(event.eventName, event.aliasEvents, event.mapFn);
        });
        getCameraEvents(this.cameraService).forEach(event => {
            defineEvent(event.eventName, event.aliasEvents, event.mapFn);
        });
        getTimelineEvents().forEach(event => {
            defineEvent(event.eventName, event.aliasEvents, event.mapFn);
        });
        getInputEvents().forEach(event => {
            defineEvent(event.eventName, event.aliasEvents, event.mapFn);
        });
        getUIEvents().forEach(event => {
            defineEvent(event.eventName, event.aliasEvents, event.mapFn);
        });
        getLabelsEvents(Human, this.store).forEach(event => {
            defineEvent(event.eventName, event.aliasEvents, event.mapFn);
        });
    }
    initProcedures() {
        getHumanProcedures(Human, this.webGLInfo).forEach(proc => {
            defineProcedure(proc);
        });
        getSceneProcedures(this.store, this.engineService, this.paintService, this.cameraService, this.graphService, this.historyService).forEach(proc => {
            defineProcedure(proc);
        });
        getCameraProcedures(this.store, this.cameraService).forEach(proc => {
            defineProcedure(proc);
        });
        getTimelineProcedures(this.store, this.actions, this.animationService).forEach(proc => {
            defineProcedure(proc);
        });
        getInputProcedures(this.store).forEach(proc => {
            defineProcedure(proc);
        });
        getUIProcedures(Human, this.store, this.actions, this.engineService, this.imageService).forEach(proc => {
            defineProcedure(proc);
        });
        getLabelsProcedures(Human, this.store, this.labelsService).forEach(proc => {
            defineProcedure(proc);
        });
    }
}
WidgetAPIHandler.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WidgetAPIHandler_Factory() { return new WidgetAPIHandler(i0.ɵɵinject(i1.Store), i0.ɵɵinject(i1.Actions), i0.ɵɵinject(i2.CameraService), i0.ɵɵinject(i3.EngineService), i0.ɵɵinject(i4.AnimationService), i0.ɵɵinject(i5.ImageService), i0.ɵɵinject(i6.PaintService), i0.ɵɵinject(i7.LabelsService), i0.ɵɵinject(i8.BdGraphService), i0.ɵɵinject(i9.HistoryService)); }, token: WidgetAPIHandler, providedIn: "root" });
